import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { Sincronizacion } from '../_models/sincronizacion';

@Injectable({
  providedIn: 'root'
})
export class SincronizacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/sincronizaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as Sincronizacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as Sincronizacion[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as Sincronizacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as Sincronizacion ) );
  }

  crear( regCrear: Sincronizacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as Sincronizacion ) );
  }

  actualizar( regActualizar: Sincronizacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
